<ng-container *transloco="let convert;">
  @if (isSellerAssociatedToMultipleLeadSellerGroup && group$ | async; as group) {
    <lib-search-filter-section
      [title]="group.groupName"
      [tagName]=tagName
      [open]="open"
      variant="link"
      [scrollable]="false"
      (openChange)="open = !open"
      >
      <span title-right class="badge badge-pill badge-light ms-auto">
        {{ selectedMemberCount$ | async }}
      </span>
      <div class="custom-control custom-checkbox mt-1">
        <input
          class="custom-control-input"
          [id]="'dealer-group-popover-select-all-' + group.uuid"
          type="checkbox"
          [appTrack]="{ elem: 'checkbox', trigger: 'filter', name: 'All ' + group.groupName }"
          (change)="toggleGroup()"
          [checked]="isGroupSelected$ | async"
          data-test-id="app-dealer-group-section-e-select-all-checkbox"
          />
        <label class="custom-control-label ms-2" [for]="'dealer-group-popover-select-all-' + group.uuid">
        {{convert('sellModule.manageInventory.dealerGroupSelection.labelAll')}} {{group.groupName}}</label>
      </div>
      <ul class="list-unstyled ps-3">
        @for (member of filteredMembers$ | async; track member; let i = $index) {
          <li class="my-3 pt-1">
            <div class="custom-control custom-checkbox">
              <input
                [id]="'dealer-group-member-select-' + member.oeUuid"
                attr.data-test-id="app-dealer-group-section-e-member-checkbox-{{i}}"
                class="custom-control-input"
                type="checkbox"
                [appTrack]="{ elem: 'checkbox', trigger: 'filter', name: member.oeName }"
                (change)="toggleMember(member.oeUuid)"
                [checked]="member.isSelected"
                />
              <label class="custom-control-label ms-2" [for]="'dealer-group-member-select-' + member.oeUuid">{{
                member.oeName
              }}</label>
            </div>
          </li>
        }
      </ul>
    </lib-search-filter-section>
  }
  @if (isSellerAssociatedToSingleLeadSellerGroup && group$ | async; as group) {
    <div>
      <div class="custom-control custom-checkbox mt-1">
        <input
          class="custom-control-input"
          [id]="'dealer-group-popover-select-all-single-' + group.uuid"
          type="checkbox"
          [appTrack]="{ elem: 'checkbox', trigger: 'filter', name: 'All ' + group.groupName }"
          (change)="toggleAllMembersInGroup()"
          [checked]="isGroupSelected$ | async"
          data-test-id="app-dealer-group-section-e-select-all-single-checkbox"
          />
        <label class="custom-control-label ms-2" [for]="'dealer-group-popover-select-all-single-' + group.uuid">
        {{group.groupName}}</label>
      </div>
      <ul class="list-unstyled ps-3">
        @for (member of filteredMembers$ | async; track member; let i = $index) {
          <li class="my-3 pt-1">
            <div class="custom-control custom-checkbox">
              <input
                [id]="'dealer-group-member-select-single-' + member.oeUuid"
                attr.data-test-id="app-dealer-group-section-e-member-checkbox-{{i}}"
                class="custom-control-input"
                type="checkbox"
                [appTrack]="{ elem: 'checkbox', trigger: 'filter', name: member.oeName }"
                (change)="toggleMember(member.oeUuid)"
                [checked]="member.isSelected"
                />
              <label class="custom-control-label ms-2" [for]="'dealer-group-member-select-single-' + member.oeUuid">{{
                member.oeName
              }}</label>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</ng-container>
